export default "__VITE_ASSET__Y1xvem5o__"